import { InvestmentPaymentMethodType } from "@verivest/shared-components/src/api/enums";

interface choosePaymentInstructionsProps {
  paymentMethod?: InvestmentPaymentMethodType | null;
  wireInstructions?: string | null;
  wireInstructionsUrl?: string | null;
  checkInstructions?: string | null;
  checkInstructionsUrl?: string | null;
}
export const choosePaymentInstructions = ({
  paymentMethod,
  wireInstructions,
  wireInstructionsUrl,
  checkInstructions,
  checkInstructionsUrl,
}: choosePaymentInstructionsProps) => {
  if (paymentMethod === InvestmentPaymentMethodType.Check) {
    return {
      instructionsText: checkInstructions,
      instructionsUrl: checkInstructionsUrl,
    };
  }

  return {
    instructionsText: wireInstructions,
    instructionsUrl: wireInstructionsUrl,
  };
};
